
class ListSortController

    ### @ngInject ###
    constructor: ($element) ->
        @ngModel = $element.controller('ngModel')
        @ngModel.$render = @render

    findOption: (value) ->
        for opt in @options
            return opt if opt.value == value
        return

    render: =>
        viewValue = @ngModel.$viewValue
        if viewValue?.length > 0
            @ascending = viewValue[0] != '-'
            @column = if @ascending then viewValue else viewValue[1..]
            @label = @findOption(@column)?.label
        return

    changeColumn: (option) ->
        @ascending = not option.desc?
        @refreshViewValue()
        return

    changeDirection: (ascending) ->
        @refreshViewValue()
        return

    refreshViewValue: =>
        viewValue = @column
        viewValue = "-#{viewValue}" if not @ascending
        @ngModel.$setViewValue viewValue
        @render()
        return



listSortDirective = ->

    restrict: 'E'
    templateUrl: 'util/widgets/listSort'
    require: 'ngModel'

    scope:
        options: '='
        column: '=?'
        direction: '=?'

    controller: ListSortController
    controllerAs: 'ctrl'
    bindToController: true


module.directive 'listSort', listSortDirective

